import * as module from '@angular/forms';

const AbstractControl = module.AbstractControl;
const DefaultValueAccessor = module.DefaultValueAccessor;
const FormControl = module.FormControl;
const FormControlDirective = module.FormControlDirective;
const NG_ASYNC_VALIDATORS = module.NG_ASYNC_VALIDATORS;
const NG_VALIDATORS = module.NG_VALIDATORS;
const NG_VALUE_ACCESSOR = module.NG_VALUE_ACCESSOR;
const NgControl = module.NgControl;
const NgModel = module.NgModel;

export default {
  AbstractControl,
  DefaultValueAccessor,
  FormControl,
  FormControlDirective,
  NG_ASYNC_VALIDATORS,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  NgControl,
  NgModel,
};
